export default __webpack_public_path__ + "static/media/AshleeChantz.8245de4d.jpeg";